<wr-new-data-table headerText="Reparaturaufträge"
                   localStorageIdentifier="contractor-repair-task-overview"
                   [loadItemsFunction]="loadRepairTasks"
                   [getCountFunction]="getCount"
                   (lineClick)="openDetail($event)"
                   [form]="form"
                   [showNewButton]="false"
                   [isAdmin]="false">
  <ng-template dataTableFilter>
    <form [formGroup]="form">
      <div class="filter-form">
        <div class="filter-control-group">
          <label class="label" for="textFilter">Textfilter</label>
          <input type="text" nbInput id="textFilter" formControlName="text" placeholder="Filter Text...">
        </div>
        <div class="filter-control-group">
          <label class="label" for="statusSelect">Status</label>
          <nb-select fullWidth id="statusSelect" data-cy="contractor-repair-task-status-filter"
                     formControlName="statusFilter" placeholder="Status auswählen">
            <nb-option [value]="openStatuses">Alle offenen</nb-option>
            <nb-option [value]="null">Alle</nb-option>
            @for (status of statusOptions; track status) {
              <nb-option [value]="status">{{ status | repairTaskStatusTranslation }}</nb-option>
            }
          </nb-select>
        </div>
        <div class="filter-control-group">
          <label class="label" for="tenantSelect">Kunde</label>
          <wr-fixed-tenant-select id="tenantSelect"
                                  formControlName="tenant"
                                  [tenants]="externalTenants()"
                                  [showEmptyOption]="true"></wr-fixed-tenant-select>
        </div>
      </div>
    </form>
  </ng-template>

  <ng-template dataColumn let-task key="status" display="Status">
    <wr-repair-task-status-text [status]="task.status"></wr-repair-task-status-text>
  </ng-template>
  <ng-template dataColumn let-task key="title" display="Titel">
    {{ task.title }}
  </ng-template>
  <ng-template dataColumn let-task key="building" exportKey="building.name" [sortable]="false" display="Gebäude">
    @if (task.building) {
      {{ task.building.name }}
    }
  </ng-template>
  <ng-template dataColumn let-task key="buildingSection" exportKey="buildingSection.sectionText" [sortable]="false" display="Adresse">
    @if (task.buildingSection) {
      {{ task.buildingSection.sectionText }}
    }
  </ng-template>
  <ng-template dataColumn let-task key="subject" exportKey="inspectionEntry.checkpointName" [sortable]="false" display="Prüfpunkt / TGA">
    @if (task.inspectionEntry) {
      {{ task.inspectionEntry.checkpointName }}
    } @else if (task.buildingEquipment) {
      {{ task.buildingEquipment.equipmentName }}
    }
  </ng-template>
  <ng-template dataColumn let-task key="deadline" display="Frist">
    @if (task.deadline) {
      {{ task.deadline | date: 'dd.MM.yyyy' }}
    }
  </ng-template>
  <ng-template dataColumn let-task key="created" display="Erstellt">
    {{ task.created | date: 'dd.MM.yyyy' }}
  </ng-template>
</wr-new-data-table>
